/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { ReactElement, useContext, useEffect, useState } from 'react'

import {
  Button,
  Col,
  Descriptions,
  message,
  PageHeader,
  Progress,
  Result,
  Row,
  Space,
  Upload,
} from 'antd'
import { ResultStatusType } from 'antd/lib/result'
import ID_COMPONENTE from 'config/idComponente'
import ICandidato from 'Models/docas/ICandidato'
import WS_DOCAS from 'Services/WS_DOCAS'

import { DocasContext } from '../Context/context'

interface IProps {
  handleClose: () => void
  atualizaAgenda: (
    limparSelecao?: boolean,
    executandoAcao?: boolean,
  ) => Promise<void>
}

const ModalImportarCandidatos = ({
  handleClose,
  atualizaAgenda,
}: IProps): ReactElement => {
  const { docasContext, setDocasContext } = useContext(DocasContext)
  const [base64, setBase64] = useState<string | null>()
  const [fileName, setFileName] = useState<string | null>()
  const [fileSize, setFileSize] = useState<number>(0)
  const [result, setResult] = useState<number>(0)
  const [resultError, setResultError] = useState<string>('')
  const [carregandoImportacao, setCarregandoImportacao] =
    useState<boolean>(false)
  const [mensagem, setMensagem] = useState<string>('')
  const [status, setStatus] = useState<ResultStatusType>()

  const handleSendFile = async () => {
    setCarregandoImportacao(true)

    if (base64) {
      const result = await WS_DOCAS.candidatos.importar(
        ID_COMPONENTE.DOCAS,
        base64.split('base64,')[1],
      )

      if (result?.status === 200) {
        setResult(200)

        if (result.data.items && result.data.items.length > 0) {
          const erros: ICandidato[] = result.data.items
          let mensagem =
            'Nem todos os candidatos foram importados com sucesso, confira ao lado os erros:'

          for (let i = 0; i < erros.length; i++) {
            mensagem +=
              ' ' + erros[i].erroImportacao + ' (placa ' + erros[i].placa + ').'
          }

          setStatus('error')
          setMensagem(mensagem)
        } else {
          setStatus('success')
          setMensagem('Arquivo importado com sucesso.')

          atualizaAgenda()
        }
      } else {
        setResult(400)
      }

      setCarregandoImportacao(false)
    }
  }

  const handleDownloadModelo = async () => {
    const result = await WS_DOCAS.candidatos.downloadModelo(ID_COMPONENTE.DOCAS)
    if (result.data.arquivo) {
      const a: any = document.createElement('a')
      a.href =
        'data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet; base64,' +
        result.data.arquivo
      a.download = 'arquivo.xlsx'
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
    }
  }

  const handleUpload = (info: any) => {
    const fileList = [...info.fileList]
    fileList.forEach(function (file, index) {
      const reader = new FileReader()
      reader.onload = (e) => {
        if (e?.target?.result) {
          setBase64(e?.target?.result.toString())
        }
      }
      reader.readAsDataURL(info.file.originFileObj)
    })
  }

  const beforeUpload = (file: any) => {
    if (
      file.type === 'application/vnd.ms-excel' ||
      file.type ==
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    ) {
      setFileName(file.name)
      setFileSize(file.size)
    } else {
      message.error(
        `${file.name} este arquivo não é uma planilha de excel válida`,
      )
    }
    return file.type === 'application/vnd.ms-excel' ||
      file.type ===
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      ? true
      : Upload.LIST_IGNORE
  }

  return (
    <>
      <PageHeader
        ghost={false}
        title="Importar Candidatos"
        extra={[
          <>
            {result < 200 && (
              <Button
                type="primary"
                disabled={!base64}
                onClick={() => handleSendFile()}
                loading={carregandoImportacao}
              >
                Importar
              </Button>
            )}
          </>,
          <Button
            type="link"
            key="download_modelo"
            onClick={() => handleDownloadModelo()}
          >
            Baixar modelo
          </Button>,
        ]}
      >
        <>
          {result === 0 ? (
            <>
              <Row>
                <Col>
                  <Upload
                    showUploadList={false}
                    multiple={false}
                    onChange={handleUpload}
                    beforeUpload={beforeUpload}
                  >
                    <Space>
                      <Button>Selecionar arquivos</Button>

                      {fileName}
                    </Space>
                  </Upload>
                </Col>
              </Row>
              <Row>
                <Descriptions
                  size="small"
                  column={1}
                  bordered
                  className="detalhes-modelo"
                >
                  <Descriptions.Item label={<b>Campo</b>}>
                    <b>Descrição</b>
                  </Descriptions.Item>
                  <Descriptions.Item label={<b>Placa</b>}>
                    Placa do veículo.
                  </Descriptions.Item>
                  <Descriptions.Item label={<b>Nome_Motorista</b>}>
                    Nome do Motorista.
                  </Descriptions.Item>
                  <Descriptions.Item label={<b>CPF_Motorista</b>}>
                    CPF do Motorista.
                  </Descriptions.Item>
                  <Descriptions.Item label={<b>CNPJ_Transportadora</b>}>
                    CNPJ da transportadora.
                  </Descriptions.Item>
                  <Descriptions.Item label={<b>Nome_Transportadora</b>}>
                    Nome da transportadora.
                  </Descriptions.Item>
                  <Descriptions.Item label={<b>Data_Previsao</b>}>
                    Data em que deve ocorrer a visita às docas para o processo
                    de Carga/Descarga.
                  </Descriptions.Item>
                  <Descriptions.Item label={<b>Hora_Previsao</b>}>
                    Hora em que deve ocorrer a visita às docas para o processo
                    de Carga/Descarga.
                  </Descriptions.Item>
                  <Descriptions.Item label={<b>Tipo</b>}>
                    Define se a visita às docas é para o processo de Carga=1, ou
                    Descarga =2, esse campo deve ser preenchido apenas com os
                    valores 1 e 2.
                  </Descriptions.Item>
                  <Descriptions.Item label={<b>Armazem</b>}>
                    Informar o nome do armazém onde ocorrerá a visita em suas
                    docas.
                  </Descriptions.Item>
                </Descriptions>
              </Row>
            </>
          ) : (
            <>
              {result === 200 ? (
                <Result
                  status={status}
                  title={mensagem}
                  extra={[
                    <Button
                      type="primary"
                      key="console"
                      onClick={() => {
                        setResult(0)
                        setResultError('')
                        setFileName(null)
                        setFileSize(0)
                        setBase64(null)
                      }}
                    >
                      Importar outro arquivo
                    </Button>,
                  ]}
                />
              ) : null}

              {result !== 200 ? (
                <Result
                  status="error"
                  title="Não foi possível importar o arquivo selecionado"
                  subTitle={resultError}
                  extra={[
                    <Button
                      type="primary"
                      key="console"
                      onClick={() => {
                        setResult(0)
                        setResultError('')
                        setFileName(null)
                        setFileSize(0)
                        setBase64(null)
                      }}
                    >
                      Tentar novamente
                    </Button>,
                  ]}
                />
              ) : null}
            </>
          )}
        </>
      </PageHeader>
    </>
  )
}

export default ModalImportarCandidatos
